// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatalbtc } from "../../../icons/full/build/icon-statalbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatalbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatalbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatalbtcIcon.displayName = 'StatalbtcIcon';
}

export default StatalbtcIcon;